export interface RegistrationStatusConfig {
    text: string;
    backgroundColor: string;
    color: string;
    toastMessage?: string;
    action?: () => Promise<void>;
    disabled?: boolean;
}

export const getRegistrationStatusConfig = (
    status: string, 
    updateRegisteredUser?: () => Promise<void>,
    updateUserUpcomingSessions?: () => Promise<void>
): RegistrationStatusConfig => {
    const configs: Record<string, RegistrationStatusConfig> = {
        'COACH_VIEW': {
            text: 'VIEW',
            backgroundColor: '#3C8248',
            color: '#ffffff',
            toastMessage: 'Viewing session stats.',
            disabled: false
        },
        'CAMPER_VIEW': {
            text: 'VIEW',
            backgroundColor: '#3C8248',
            color: '#ffffff',
            toastMessage: 'You are registered for this session.',
            disabled: false
        },
        'REGISTER': {
            text: 'REGISTER',
            backgroundColor: '#3C8248',
            color: '#ffffff',
            action: updateRegisteredUser && updateUserUpcomingSessions ? 
                async () => {
                    await updateRegisteredUser();
                    await updateUserUpcomingSessions();
                } : undefined,
            toastMessage: 'SnapCamp session registration success!',
            disabled: false
        },
        'FULL': {
            text: 'FULL',
            backgroundColor: '#DC3545',
            color: '#ffffff',
            toastMessage: 'Selected session is already full.',
            disabled: false
        },
        'DISABLED_VIEW': {
            text: 'VIEW', // Same text as other VIEW types
            backgroundColor: '#6C757D',
            color: '#ffffff',
            disabled: true
        }
    };
    
    return configs[status] || {
        text: status,
        backgroundColor: '#6C757D',
        color: '#ffffff',
        disabled: false
    };
}; 